export const columns = [
  {
    title: 'Id',
    name: 'id'
  },
  {
    title: 'Nombre',
    name: 'name'
  },
  {
    title: 'Permisos',
    name: 'countPermissions'
  }
];

export const mapData = data =>
  data.map(datum => {
    return {
      ...datum,
      name: datum.displayName || '--',
      countPermissions: datum.permissions.length
    };
  });
